import firebase from "./firebase";

// Re-export Firebase types to ensure they're accessible throughout the app
export type FirebaseApp = typeof firebase;
export type FirebaseAuth = firebase.auth.Auth;
export type FirebaseUser = firebase.User;
export type FirebaseFirestore = firebase.firestore.Firestore;
export type FirebaseAuthError = firebase.auth.Error;

// Re-export Firestore types
export type FirestoreDocumentData = firebase.firestore.DocumentData;
export type FirestoreDocumentSnapshot =
  firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>;
export type FirestoreQueryDocumentSnapshot =
  firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>;
export type FirestoreQuerySnapshot =
  firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>;
export type FirestoreFieldPath = typeof firebase.firestore.FieldPath;
export type FirestoreFieldValue = typeof firebase.firestore.FieldValue;

// Export namespaces to match legacy code
export const firestore = firebase.firestore;
export const firebaseAuth = firebase.auth;

// Export FieldPath and FieldValue directly
export const FieldPath = firebase.firestore.FieldPath;
export const FieldValue = firebase.firestore.FieldValue;

// Export EmailAuthProvider
export const EmailAuthProvider = firebase.auth.EmailAuthProvider;

// Helper to get auth instance
export const getAuth = () => firebase.auth();

// Helper to get firestore instance
export const getFirestore = () => firebase.firestore();

export default firebase;
